/* Navbar: selector de idioma (submenú ES / EN) */
(function () {
    const wraps = document.querySelectorAll('[data-melo-nav-lang]');
    if (!wraps.length) {
        return;
    }

    function setOpen(wrap, open) {
        const trigger = wrap.querySelector('[data-melo-nav-lang-trigger]');
        const menu = wrap.querySelector('[data-melo-nav-lang-menu]');
        if (!trigger || !menu) {
            return;
        }
        wrap.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        menu.hidden = !open;
        if (open) {
            menu.style.display = 'flex';
        } else {
            menu.style.display = 'none';
        }
    }

    function closeAll(exceptWrap) {
        wraps.forEach(function (wrap) {
            if (wrap !== exceptWrap && wrap.classList.contains('is-open')) {
                setOpen(wrap, false);
            }
        });
    }

    wraps.forEach(function (wrap) {
        const trigger = wrap.querySelector('[data-melo-nav-lang-trigger]');
        if (!trigger) {
            return;
        }

        // Initialize as closed
        setOpen(wrap, false);

        trigger.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            const willOpen = !wrap.classList.contains('is-open');
            if (willOpen) {
                document.documentElement.classList.remove('melo-nav-animate');
                closeAll(wrap);
                document.dispatchEvent(new CustomEvent('melo-nav-lang-open'));
            }
            setOpen(wrap, willOpen);
        });
    });

    document.addEventListener('click', function (event) {
        if (event.target.closest('[data-melo-nav-lang]')) {
            return;
        }
        closeAll(null);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeAll(null);
        }
    });

    document.addEventListener('melo-nav-menu-closed', function () {
        closeAll(null);
    });

    document.addEventListener('melo-nav-solutions-open', function () {
        closeAll(null);
    });
})();
